module.exports = __webpack_public_path__ + "gu.037043f8.svg";